import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import FastRewindRoundedIcon from "@mui/icons-material/FastRewindRounded";
import FastForwardRoundedIcon from "@mui/icons-material/FastForwardRounded";
import Tooltip from "@mui/material/Tooltip";

const RightSpeedControl = ({ playbackSpeed, onCycleSpeed }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #c4c8d0",
        borderRadius: "16px",
        px: 0.5,
        py: 0.1,
        backgroundColor: "#fff",
        gap: 0.25,
      }}
    >
      <Tooltip title="Decrease speed">
        <IconButton
          size="small"
          onClick={() => onCycleSpeed(-1)}
          sx={{ color: "#24336f", p: 0.25 }}
        >
          <FastRewindRoundedIcon sx={{ fontSize: 17 }} />
        </IconButton>
      </Tooltip>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 600,
          color: "#24336f",
          minWidth: 42,
          textAlign: "center",
          userSelect: "none",
        }}
      >
        {playbackSpeed}
      </Typography>
      <Tooltip title="Increase speed">
        <IconButton
          size="small"
          onClick={() => onCycleSpeed(1)}
          sx={{ color: "#24336f", p: 0.25 }}
        >
          <FastForwardRoundedIcon sx={{ fontSize: 17 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

RightSpeedControl.propTypes = {
  playbackSpeed: PropTypes.string.isRequired,
  onCycleSpeed: PropTypes.func.isRequired,
};

export default RightSpeedControl;
